<script>
    import f9input2 from 'inputs/f9input2.vue';
    import f9field2 from 'inputs/f9field2.vue';
    import f9button2 from 'inputs/f9button2.vue';
    import f9link from 'inputs/f9link.vue';
    import error2 from "shared/Components/error2.vue";
    import BagPriceWidgetHeader from './BagPriceWidgetHeader.vue';
    import { params } from "shared/query";

    export default {
        props: {
            "validationScope": {
                type: String,
                default: "bag-price-existing-trip"
            },
            doneSearching: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                searchParams: {
                    pnr: "",
                    lastName: ""
                },
                searching: false,
                searchError: false
            }
        },
        methods: {
            search() {
                this.searchError = false;
                this.validate(this.validationScope).then(result => {
                    if(result) {
                        this.searching = true;
                        this.$emit("search", this.searchParams);
                    }
                });
            }
        },
        watch: {
            doneSearching(val) {
                if(val) {
                    this.searching = false;
                }
            }
        },
        mounted() {
            const query = params();
            if(query && query.pnr && query.lastName) {
                this.searchParams = {
                    pnr: query.pnr,
                    lastName: query.lastName
                };
                
                this.$nextTick(() => {
                    this.$el.scrollIntoView({ behavior: "smooth" });
                    this.search()
                });
            }

            this.$root.$on('bookingNotFound', val => this.searchError = val);
        },
        components: {
            f9input2,
            f9field2,
            f9button2,
            f9link,
            error2,
            BagPriceWidgetHeader
        }
    }
</script>

<template>
    <div class="existing-trip-container">
        <bag-price-widget-header></bag-price-widget-header>
        <form class="existing-trip-form">
            <div class="form-inputs">
                <f9field2 class="last-name-field">
                    <span slot="label" class="last-name-label">Last Name *</span>
                    <f9input2 name="last_name" v-model="searchParams.lastName" type="text" autocomplete="off" v-validate="'required'" 
                    data-vv-validate-on="" :data-vv-scope="validationScope"></f9input2>
                </f9field2>
                <f9field2 class="pnr-field">
                    <div slot="label" class="confirmation-code-label">Confirmation Code * 
                        <f9link class="how-to-find-link" href="https://www.flyfrontier.com/manage-travel/confirmation-code" target="_blank"><span>How to Find</span><img class="how-to-find-icon" src="https://flyfrontier-com-frontdoor-en-chh3dufqdpdff8h9.a02.azurefd.net/images/circle_questionmrk_white.svg" alt=""/></f9link>
                    </div>
                    <f9input2 name="pnr" v-model="searchParams.pnr" type="text" autocomplete="off" v-validate="'required'" 
                    data-vv-validate-on="" :data-vv-scope="validationScope"></f9input2>
                </f9field2>
            </div>
            <error2 v-if="searchError">Booking not found.</error2>
            <f9button2 class="existing-trip-search-button" ref="searchButton" name="submit" @click="search" :loading="searching">CHECK BAG PRICES</f9button2>
        </form>
    </div>
</template>

<style lang="less" scoped>
    @import "~less-variables";

    .existing-trip-container {
        width: 100%;
        height: 100%;
        color: @white;
        line-height: normal;
        letter-spacing: normal;
        background-image: linear-gradient(-1deg, #576e77 0%, #3b4e55 100%);
        padding: 19px 32px 24px 32px;

        .existing-trip-form {
            display: flex;
            flex-direction: column;
            padding-top: 9px;

            .form-inputs {
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                width: 100%;
                
                .last-name-field, 
                .pnr-field {
                    width: 315px;
                    padding-top: 6px;
                    margin-top: 0;
                    font-size: 12px;
                    font-weight: 400;
                    color: @white;

                    input {
                        margin-top: 7px;
                        -webkit-border-radius: 2px;
                        border-radius: 2px;
                        height: 40px;
                        border: 1px solid #d6d7d5;
                        font-size: 16px;
                        padding-top: 8px;
                    }
                }

                .confirmation-code-label {
                    display: flex;
                    justify-content: space-between;
                    width: 100%;

                    .how-to-find-link {
                        display: flex;
                        align-items: flex-end;
                        justify-content: flex-end;
                        font-size: 11px;
                        color: @white;
                        text-decoration: none;

                        .how-to-find-icon {
                            margin-left: 4px;
                            margin-right: 2px;
                        }
                    }
                }
            }

            .existing-trip-search-button {
                align-self: flex-end;
                width: 315px;
                margin-top: 19px;
            }
        }
    }

    @media @tablet-lg {
        .existing-trip-container {
            height: 100%;
            padding-top: 24px;

            .existing-trip-form {
                .form-inputs {
                    .last-name-field, 
                    .pnr-field {
                        padding-top: 3px;
                    }
                }
            }
        }
    }

    @media @tablet {
        .existing-trip-container {
            height: 100%;
            padding: 15px;

            .existing-trip-form {
                .form-inputs {
                    flex-direction: column;

                    .last-name-field {
                        width: 100%;
                        padding-top: 3px;

                        input {
                            margin-top: 6px;
                        }
                    }

                    .pnr-field {
                        width: 100%;
                        padding-top: 15px;
                        margin-top: 0;
                    }
                }

                .existing-trip-search-button {
                    align-self: flex-start;
                    margin-top: 15px;
                    width: 100%;
                }
            }
        }
    }
</style>
